module.exports = __webpack_public_path__ + "img/bus_03.d7071f86.jpg";